import { TrainingInfoModel } from './training-info.model';

export class SpecialtyModel {
  public uuid: string;
  public nid: number;
  public name: string;
  public type: string;
  public link: string;
  public imageUrl: string;
  public isChecked: boolean;
  public description: string;
  public overview: string;
  public associations: string;
  public association_logo: string;
  public path: any;
  public trainingInfoModel: TrainingInfoModel;
  public metatags: any;
  public subSpecialties: [
    {
      title: string;
      path: string;
    }
  ];
  public relatedPrograms: [
    {
      title: string;
      field_program_id: number;
    }
  ];
  // Icons
  public definingFeatures: [];

  constructor(values?: Partial<SpecialtyModel>) {
    Object.assign(this, values);
  }
}
